import React from 'react';
import {ColumnHeaderSortable} from '../../DataTable/index.jsx';
import Column from './base.jsx';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from "react-bootstrap/Popover";

var columnOptions = {
    id: 'w',
    title: 'Our Rating'
};
let id = 0;

class HeaderColumn extends ColumnHeaderSortable {
    get id() {
        return columnOptions.id;
    }

    get title() {
        return columnOptions.title;
    }

    get overlayText() {
        return "Collective Shift's bullish or bearish rating of cryptocurrencies";
    }
}


class DetailColumn extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            id: id++
        };
    }

    overlay() {
        return (
            <Popover id={"popover-positioned-" + this.state.id} className={"p-2 cs-text pre-line"}>
                {this.props.row.indicatortext}
            </Popover>
        );
    }

    render() {
        let popup, btnclass;
        const assetIndicator= {
            1 :'Very Bullish',
            2 :'Moderately Bullish',
            3 :'Slightly Bullish',
            4 :'Neutral',
            5 :'Bearish'
        }
        switch(this.props.row.indicator) {
            case 1:
                btnclass = 'btn-very-very-good'
                break
            case 2:
                btnclass = 'btn-very-good'
                break
            case 3:
                btnclass = 'btn-good'
                break
            case 4:
                btnclass = 'btn-neutral'
                break
            case 5:
                btnclass = 'btn-very-very-bad'
                break
        }

        if (this.props.row.indicator && this.props.row.upgradeurl === '') {
            popup = <OverlayTrigger overlay={this.overlay()} trigger="focus" placement="auto">
                            <button
                                className={`btn btn-sm btn-block text-nowrap ${btnclass}`}
                                role="button"
                            >
                                {assetIndicator[this.props.row.indicator]}
                            </button>
                        </OverlayTrigger>
        } else if (this.props.row.upgradeurl !== '') {
            popup = <a href={this.props.row.upgradeurl} className="btn btn-sm btn-block btn-primary">Upgrade</a>
        } else {
            popup = ''
        }
        return (
            <td>
                {popup}
            </td>
        );
    }
}


class Indicator extends Column {
    get id() {
        return columnOptions.id;
    }

    get title() {
        return columnOptions.title;
    }

    sortAscending(a, b) {
        if (! a.indicator) {
            return 1;
        }
        if (! b.indicator) {
            return -1;
        }
        if (a.indicator < b.indicator) {
            return -1;
        }
        if (a.indicator > b.indicator) {
            return 1;
        }
        return super.sortAscending(a, b);
    }

    sortDescending(a, b) {
        if (! a.indicator) {
            return 1;
        }
        if (! b.indicator) {
            return -1;
        }
        if (a.indicator < b.indicator) {
            return 1;
        }
        if (a.indicator > b.indicator) {
            return -1;
        }
        return super.sortDescending(a, b);
    }

    get DetailColumn() {
        return DetailColumn;
    }

    get HeaderColumn() {
        return HeaderColumn;
    }
}


export default Indicator;

